<template>
    <div class="product-section">
        <div class="content-wrapper" style="padding-bottom: 5rem">
            <div class="section-header">
                <h2 class="section-title">
                    <span class="title-deco"></span>
                    Industrial Sealing
                    <div class="title-line-good"></div>
                </h2>
                <p class="c-p">Precision Solutions, Hassle-Free Customization</p>
            </div>

            <div class="product-grid">
                <div
                    v-for="(product, index) in featuredProducts"
                    :key="product.id"
                    class="product-item"
                    :class="{ 'reverse': index % 2 !== 0 }"
                    @mousemove="handleParallax($event, index)"
                    @mouseleave="resetParallax(index)"
                >
                    <div class="image-container">
                        <img
                            :src="product.image"
                            alt="Product"
                            :style="parallaxStyles[index]"
                            loading="lazy" decoding="async"
                        />
                        <div class="image-overlay"></div>
                    </div>
                    <div class="text-container">
                        <h3 class="product-title">{{ product.title }}</h3>
                        <p class="product-desc" v-html="product.desc"></p>
                        <button class="view-btn" @click="goProducts(product.category)">
                            Learn More
                            <div class="btn-underline"></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default {
    data() {
        return {
            featuredProducts: [
                {
                    id: 1,
                    image: require("@/assets/img/orings.jpg"),
                    category: '1',
                    title: "Full Range O-Ring Solutions",
                    desc: "Standard Part: AS568 Size 37 (Tolerance ±1.5%) <br> Custom Solutions: Custom Development Supported by Customer Drawings/Samples (Provide Medium, Temperature, and Pressure Parameters)"
                },
                {
                    id: 2,
                    image: require("@/assets/img/seals.jpg"),
                    category: '9',
                    title: "Mechanical Sealing System",
                    desc: "High Precision: ≤30 MPa (±5% tolerance) <br> Material Options: NBR｜FKM｜EPDM｜SILICONE"
                },
                {
                    id: 3,
                    image: require("@/assets/img/FFKM.jpg"),
                    category: '1',
                    title: "Specialty Rubber Products",
                    desc: "FFKM: Temperature Resistance < 300 ℃  <br> FDA/Medical certification requires prior communication. Please provide details on application scenarios, contact media, sterilization methods, and regulatory standards"
                },
                {
                    id: 4,
                    image: require("@/assets/img/k.jpg"),
                    category: '4',
                    title: "Ready-to-use Sealing Kit",
                    desc: "Automotive Fuel/Cooling System Repair Kit  <br> Industrial Emergency Multi-Material Quick-Change Kit"
                }
            ],
            parallaxStyles: {}
        };
    },
    mounted() {
        // 初始化 Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-item');
                }
            });
        }, {
            threshold: 0.1,      // 当元素可见10%时触发
            rootMargin: "0px"     // 无额外边界偏移
        });

        // 在 DOM 更新后绑定观察器
        this.$nextTick(() => {
            // 观察所有 product-item 元素
            const items = document.querySelectorAll('.product-item');
            items.forEach((item, index) => {
                observer.observe(item);

                // 为每个 item 添加阶梯延迟
                item.style.transitionDelay = `${index * 0.2}s`;
            });
        });
        // this.$nextTick(() => {
        //   this.initParallaxStyles();
        //   this.initAnimations();
        //   ScrollTrigger.refresh();
        // });
    },
    methods: {
        initParallaxStyles() {
            this.featuredProducts.forEach((_, index) => {
                this.parallaxStyles[index] = { transform: "translate(0, 0) scale(1)" };
            });
        },
        initAnimations() {
            gsap.registerPlugin(ScrollTrigger);

            // 统一卡片入场动画（合并原有两个动画）
            const productItems = gsap.utils.toArray(".product-item");
            productItems.forEach((item, index) => {
                gsap.fromTo(item,
                    {
                        opacity: 0.1,  // 初始半透明
                        y: 60
                    },
                    {
                        scrollTrigger: {
                            trigger: item,
                            start: "top 80%",
                            end: "bottom 20%",
                            toggleActions: "play none none reverse",
                            scrub: 0.5
                        },
                        opacity: 1,     // 过渡到不透明
                        y: 0,
                        duration: 1.2,
                        ease: "power4.out",
                        delay: index * 0.2  // 阶梯延迟
                    }
                );
            });

            // 标题动画
            gsap.utils.toArray(".product-title").forEach((title, index) => {
                gsap.fromTo(title,
                    { opacity: 0, y: 30 },
                    {
                        scrollTrigger: {
                            trigger: title,
                            start: "top 70%",
                            toggleActions: "play none none none"
                        },
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        delay: 0.3,
                        ease: "expo.out"
                    }
                );
            });

            // 描述文字动画
            gsap.utils.toArray(".product-desc").forEach((desc, index) => {
                gsap.fromTo(desc,
                    { opacity: 0, y: 20 },
                    {
                        scrollTrigger: {
                            trigger: desc,
                            start: "top 80%",
                            toggleActions: "play none none none"
                        },
                        opacity: 1,
                        y: 0,
                        duration: 1,
                        delay: 0.5,
                        ease: "elastic.out(1, 0.3)"
                    }
                );
            });
        },

        handleParallax(e, index) {
            const rect = e.currentTarget.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width - 0.5;
            const y = (e.clientY - rect.top) / rect.height - 0.5;
            gsap.set(this.parallaxStyles[index], {
                transform: `translate3d(${x * 20}px, ${y * 20}px, 0) scale(1.05)`
            });
        },

        resetParallax(index) {
            gsap.set(this.parallaxStyles[index], {
                transform: "translate3d(0, 0, 0) scale(1)"
            });
        },
        goProducts(categoryId) {
            this.$router.push({
                path: '/products',
                query: { category: categoryId }
            });
        }
    },
    beforeUnmount() {
        // // 清理所有GSAP实例
        // ScrollTrigger.getAll().forEach(t => t.kill())
        // gsap.globalTimeline.clear()
    }
};
</script>

<style scoped lang="scss">
.product-section {
    padding: 12vh 0;
    overflow: hidden;
    background: transparent; /* 原背景色 #0A1A2F 移除 */
    backdrop-filter: blur(20px);
    border: 1px solid rgba(197, 164, 126, 0.1);
    will-change: backdrop-filter, transform;

    position: relative;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
                to bottom,
                rgba(14, 32, 55, 0.7) 0%,
                rgba(10, 26, 47, 0.9) 5%
        );
    }

}

.section-header {
    position: relative;
    text-align: center;
    margin-bottom: 4rem;

    .c-p {
        font-size: 1.1rem;
        letter-spacing: 0.2em;
        color: rgba(255, 255, 255, 0.7);
    }
}

.title-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    height: 400px;
    background: radial-gradient(
            circle,
            rgba(197, 164, 126, 0.1) 0%,
            transparent 70%
    );
    transform: translate(-50%, -50%);
    filter: blur(80px);
}

.section-title {
    font-size: 2.8rem;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.95);
    position: relative;
    display: inline-block;
    margin-bottom: 1.5rem;
}

.title-deco {
    color: #c5a47e;
    margin-right: 1.5rem;
    opacity: 0.8;
}

.title-underline {
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 80%;
    height: 2px;
    background: linear-gradient(90deg, #c5a47e 30%, transparent 100%);
    transform-origin: left center;
}

.product-grid {
    display: grid;
    gap: 4rem;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 2rem;
}

.product-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    padding: 3rem;
    border-radius: 24px;
    //background: rgba(16, 36, 61, 0.5);
    backdrop-filter: blur(12px);
    position: relative;
    overflow: hidden;
    transform: translateZ(0);
    backface-visibility: hidden;
    transition: opacity 0.6s ease;
    will-change: transform, opacity;
    background: rgba(16, 34, 54, 0.6);
    border: 1px solid rgba(166, 138, 100, 0.25);

}

.product-item.reverse {
    grid-template-columns: 1fr 1.2fr;
    direction: rtl;
}

.image-container {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    perspective: 1200px;
    transform-style: preserve-3d;
    aspect-ratio: 16/9; /* 新增固定宽高比 */
    max-width: 800px; /* 新增最大宽度限制 */
    margin: 0 auto; /* 居中显示 */
}

.image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
    will-change: transform; /* 声明动画属性 */
    object-position: center center; /* 新增居中定位 */
}

.image-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
            45deg,
            rgba(10, 26, 47, 0.6) 0%,
            transparent 60%
    );
}

.hover-glow {
    position: absolute;
    inset: -20px;
    background: radial-gradient(
            circle,
            rgba(197, 164, 126, 0.1) 0%,
            transparent 70%
    );
    filter: blur(30px);
    opacity: 0;
    transition: opacity 0.6s ease;
}

.product-item:hover .hover-glow {
    opacity: 0.4;
}

.text-container {
    position: relative;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.product-title {
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
    color: #c5a47e;
    margin-bottom: 1.5rem;
    margin-top: 1.2rem;
    position: relative;
    transition: transform 0.3s ease;
}

.product-desc {
    font-size: 1.1rem;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1rem;
}

.view-btn {
    align-self: flex-start;
    background: transparent;
    border: none;
    color: #c5a47e;
    padding: 0;
    font-size: 1.1rem;
    position: relative;
}

.btn-underline {
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 1px;
    background: currentColor;
    transition: width 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.view-btn:hover .btn-underline {
    width: 100%;
}

/* 移动端适配增强 */
@media (max-width: 1024px) {
    .product-item {
        grid-template-columns: 1fr !important;
        gap: 2rem;
        direction: ltr !important;
        padding: 2rem 1rem; /* 减少左右padding */
        border-radius: 16px; /* 减少移动端圆角 */
    }

    .image-container {
        max-width: 100%;
        aspect-ratio: 16/9;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .image-container img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .product-title {
        font-size: 1.6rem;
    }

    .product-desc {
        font-size: 1rem;
        line-height: 1.5;
    }

    .text-container {
        margin: 0 !important;
    }
}

@media (max-width: 768px) {
    .product-item {
        padding: 1.5rem;
    }

    .section-title {
        font-size: 2.4rem;
    }
}

@media (max-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    .product-section {
        backdrop-filter: none;
    }

    .product-item {
        backdrop-filter: none !important;
    }
}


.product-item {
    opacity: 0;
    transform: translateY(60px);
    transition: opacity 1.2s ease,
    transform 1.2s ease;

    &.animate-item {
        opacity: 1;
        transform: translateY(0);
    }
}

.product-title {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s 0.3s ease-out,
    transform 0.8s 0.3s ease-out;

    .animate-item & {
        opacity: 1;
        transform: translateY(0);
    }
}

.product-desc {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 1s 0.5s cubic-bezier(0.5, 0, 0, 1),
    transform 1s 0.5s cubic-bezier(0.5, 0, 0, 1);

    .animate-item & {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
